<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div>
        IME:
        <input type="tect" v-model="job.name" />
      </div>
      <div>
        LOKACIJA:
        <input type="text" v-model="job.location" />
      </div>
      <div>
        GENERALNI OPIS:
        <textarea v-model="job.generalDescription" />
      </div>
      <div>
        <div>ZAHTJEVI (za točan prikaz zahtjeva treba dodat - prije svake natuknice):</div>
        <textarea v-model="job.requirements" />
      </div>
      <div>
        <div>OČEKIVANJA (za točan prikaz očekivanja treba dodat - prije svake natuknice):</div>
        <textarea v-model="job.expectations" />
      </div>
      <div>
        TIP POSLA:
        <select v-model="job.jobType">
          <option v-for="jobType in jobTypes" v-bind:value="jobType" v-bind:key="jobType">{{ jobType }}</option>
        </select>
      </div>
      <div>
        LINK:
        <input type="text" v-model="job.link" />
      </div>
      <div>
        SPONZOR:
        <select v-model="job.company" v-if="job.isAdd">
          <option v-for="company in companies" v-bind:value="company" v-bind:key="company.id">
            {{ company.name }}
          </option>
        </select>
        <span v-if="!job.isAdd && job.company">{{ job.company.name }}</span>
      </div>
      <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="isJobValid" v-on:click="$emit('save', job)">SPREMI</button>
        <button type="button" v-on:click="$emit('cancel', job)">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', job)"></a>
  </div>
</template>

<script>
export default {
  name: 'AddEditJobModal',
  props: {
    job: {},
    jobTypes: Array,
    companies: Array,
  },
  computed: {
    isJobValid: function() {
      return (
        !this.job.name ||
        !this.job.company ||
        !this.job.location ||
        !this.job.generalDescription ||
        !this.job.requirements ||
        this.splitArgumentByDashDelimiter(this.job.requirements).length === 0 ||
        !this.job.expectations ||
        this.splitArgumentByDashDelimiter(this.job.expectations).length === 0 ||
        !this.job.jobType
      );
    },
  },
  methods: {
    splitArgumentByDashDelimiter: function(arg) {
      return arg.split('-').splice(1);
    },
  },
};
</script>
